export const LocationIcon = () => {
  return (
    <svg width="10px" height="16px" viewBox="0 0 10 16" version="1.1">
      <title>Fill 1</title>
      <g id="QSR" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Delivery--Schedule-time"
          transform="translate(-47.000000, -469.000000)"
          fill="#14B2B6"
        >
          <g id="Group" transform="translate(47.000000, 465.000000)">
            <g
              id="Group-3"
              transform="translate(5.000000, 12.000000) scale(-1, 1) translate(-5.000000, -12.000000) translate(0.000000, 4.000000)"
            >
              <path
                d="M2,5.18889526 C2,3.41695787 3.361813,2 5.0647905,2 C6.76421173,2 8.129581,3.41745124 8.129581,5.18889526 C8.129581,6.95639232 6.76350048,8.37779052 5.0647905,8.37779052 C3.36252425,8.37779052 2,6.95713238 2,5.18889526 Z M0,5.20261205 C0,7.81166518 1.86636517,9.98028099 4.28232634,10.3466904 L4.27901718,15.7038884 C4.27901718,15.8674384 4.40669553,16 4.56388054,16 L5.42950114,16 C5.58668615,16 5.71408874,15.8674384 5.71408874,15.7038884 L5.7173979,10.3464035 C8.13446212,9.98315029 10,7.81453448 10,5.20232512 C10,2.33474819 7.75225436,0 4.99986212,0 C2.24443648,0.000286929851 0,2.33560898 0,5.20261205 Z"
                id="Fill-1"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
